import { NavigateAction } from 'react-big-calendar';
import {Box, IconButton, styled} from "@mui/material";
import theme, {FONTS} from "../../../constants/theme";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CalendarLegend from "../legend";
import React from "react";
import {scale} from "../../../utils";
import {useMediaQuery} from "@mui/system";

interface CustomToolbarProps {
  label: string;
  onNavigate: (action: NavigateAction) => void;
}

export const ToolbarContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: 'transparent',
  padding: scale(13),
  borderRadius: '10px 10px 0 0',
  gap: scale(27.22),
  color: 'white',
  fontWeight: 'bold',
  [theme.breakpoints.down('sm')]: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: '0 0 0 0',
    width: '100vw',
    alignSelf: 'anchor-center',
  },
});

export const ToolbarButtonGroup = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
});

export const ToolbarButton = styled(IconButton)({
  backgroundColor: '#1976d2',
  textAlign: 'center',
  border: 'none',
  color: 'white',
  cursor: 'pointer',
  borderRadius: '50%',
  width: scale(35),
  height: scale(35),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  [theme.breakpoints.down('sm')]: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
});

export const ToolbarLabel = styled('span')({
  fontSize: scale(24),
  fontWeight: 'bold',
  fontFamily: FONTS.MONTSERRAT,
  textTransform: 'uppercase',
  lineHeight: scale(34),
  color: theme.palette.text.secondary,
  [theme.breakpoints.down('sm')]: {
    color: 'white',
  },
});


const ToolbarComponent = ({ label, onNavigate }: CustomToolbarProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <ToolbarContainer>
      <Box sx={{flexBasis: isMobile ? 0 : scale(300)}}/>
      <Box sx={{ position: 'relative', right: scale(4), display: 'flex', flexDirection: 'row', justifyItems: 'center', justifyContent: isMobile ? 'center' : 'space-between', alignItems: 'center', gap: scale(27.22) , flexBasis: isMobile ? scale(600) : scale(350)}}>
        <ToolbarButtonGroup>
          <ToolbarButton onClick={() => onNavigate('PREV')}>
            <NavigateBeforeIcon
              sx={{
                fontSize: scale(42),
                marginRight: '1px',
              }}
            />
          </ToolbarButton>
        </ToolbarButtonGroup>
        <ToolbarLabel>{label}</ToolbarLabel>
        <ToolbarButtonGroup>
          <ToolbarButton onClick={() => onNavigate('NEXT')}>
            <NavigateNextIcon
              sx={{
                fontSize: scale(42),
                marginLeft: '1px',
              }}
            />
          </ToolbarButton>
        </ToolbarButtonGroup>
      </Box>
      {!isMobile ? (<CalendarLegend/>) :
        (
          <CalendarLegend
            sx={{
              position: 'fixed',
              bottom: scale(4),
              left: '25%',
              backgroundColor: theme.palette.white.main,
              boxShadow: '0px 3px 6px #00000029',
              zIndex: 300,
            }}
          />
        )}
    </ToolbarContainer>
  );
};

export default ToolbarComponent;
